<template>
    <div>
        <f-dialog
            v-model       = "edit"
            :width        = "600"
            :show-header  = "false"
            :hide-actions = "true"
            content-class = "dialog-border"
            @cancel       = "onCancel"
        >
            <template v-slot:content>
                <div style="position: relative" class="pl-2 mr-2">
                    <div class="close-button">
                        <c-toolbar-button
                            size     = "28"
                            color    = "red"
                            icon     = "mdi-close"
                            :tooltip = "$t('common.cancel')"
                            @click   = "onCancel"
                        />
                    </div>

                    <div v-if="information" class="mt-5 mb-3">
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    :label = "$t('dms.info.name')"
                                    :value = "information.name"
                                    dense
                                    filled
                                />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame mt-6">
                            <v-col class="no-frame col-3">
                                <f-read-only-field
                                    :label = "$t('dms.info.size')"
                                    :value = "size"
                                    :align-right = "true"
                                    dense
                                    filled
                                />
                            </v-col>
                            <v-col class="no-frame pl-2">
                                <f-read-only-field
                                    :label = "$t('dms.info.createdBy')"
                                    :value = "information.owner"
                                    dense
                                    filled
                                />
                            </v-col>
                            <v-col class="no-frame pl-2">
                                <f-read-only-field
                                    :label = "$t('dms.info.modifiedBy')"
                                    :value = "information.modifiedBy"
                                    dense
                                    filled
                                />
                            </v-col>
                        </v-row>

                        <v-row class="no-frame mt-1">
                            <v-col class="no-frame col-3">
                                <f-read-only-field
                                    :label = "$t('dms.info.filetype')"
                                    :value = "information.filetype.name"
                                    dense
                                    filled
                                />
                            </v-col>
                            <v-col class="no-frame pl-2">

                                <f-read-only-field
                                    :label = "$t('dms.info.createdDate')"
                                    :value = "format (information.created)"
                                    dense
                                    filled
                                />
                            </v-col>

                            <v-col class="no-frame pl-2">
                                <f-read-only-field
                                    :label = "$t('dms.info.modifiedDate')"
                                    :value = "format (information.modified)"
                                    dense
                                    filled
                                />
                            </v-col>
                        </v-row>

                        <v-row dense class="mt-5">
                            <v-col class="no-frame">
                                <f-read-only-field
                                    :label = "$t('dms.info.id')"
                                    :value = "information.id"
                                    dense
                                    filled
                                />
                            </v-col>
                        </v-row>

                        <v-row class="no-frame mt-6 mb-5">
                            <v-col class="no-frame">
                                <div class="primary--text" style="font-size: 12px">
                                    {{ $t('dms.info.reference') }}
                                </div>
                                <div v-for="(parent, index) in information.parents" :key="index">
                                    <f-read-only-field
                                        :value="parent"
                                        dense
                                        filled
                                    />
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </template>
        </f-dialog>
    </div>
</template>

<script>

import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import FDialog from "@/modules/core/components/utils/FDialog.vue";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";
import Core from "@/modules/core/service/Core";

export default {
    name: "PDmsInformation",

    components: {
        FReadOnlyField,
        CToolbarButton,
        FDialog
    },

    props: {
        information: {

        },
        value: {

        }
    },

    data() {
        return {
            type    : null,
            filename: null,
            edit    : false,
        };
    },

    computed: {
        size () {
            if (!this.information.size) {
                return null;
            }

            return ((this.information.size / 1024) | 0) + " KB"
        }
    },

    watch: {
        value () {
            this.edit = this.value;
        }
    },

    methods: {
        onCancel () {
            this.$emit("input", false);
        },

        format (value) {
            if (!value) {
                return "---"
            }
            return Core.format.datetime.display(value);
        },
    }
}
</script>

<style scoped>

.close-button {
    position: absolute;
    z-index: 10;
    right: 0;
    top: -8px;
}

</style>